<section id="about">
    <div class="container">
        <h2><strong>About</strong></h2>
        <span class="bar-title mb-5"></span>
        <div class="row">
            <div class="col-lg-4 col-md-12" data-aos="fade-right" >

                <picture>
                    <img src="assets/images/profile.jpg" alt="profile photo" class="img-fluid">
                </picture>
               <div class="d-flex justify-content-center">
                    <a  class="btn-social-media" href="https://www.linkedin.com/in/matthew-riney/" rel="tooltip" target="_blank"  title="Linkedin">
                        <i  class="fa fa-linkedin fa-lg "></i>
                    </a>
                    <a class="btn-social-media btn-default btn-round btn-lg btn-icon" href="https://github.com/mattriney" rel="tooltip" target="_blank" title="GitHub" >
                        <i  class="fa fa-github fa-lg "></i></a>
                </div>


            </div>
            <div class="col-lg-8  col-md-12 pt-4 pt-lg-0" data-aos="fade-left">
                <h3>Software Developer </h3>
                <p class="font-italic">
                  Passionate about all things tech.
                </p>
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <ul>
                            <li>
                                <fa-icon [icon]="home"></fa-icon><strong> Missouri, USA</strong>
                            </li>
                            <li>
                                <fa-icon [icon]="email"></fa-icon><strong><a href="mailto:matt.riney@protonmail.com">
                                        matt.riney@protonmail.com</a></strong>
                            </li>

                        </ul>
                    </div>
                </div>
                <p>

                </p>
            </div>
        </div>
    </div>
</section>
